var configDatas = [
  {
    label_id: 59000,
    name: "GearLab Label",
    priority: 0,
    img_url: "ec_2022_lg.png",
    pages: "2",
    enable_allowed_countries: false,
    locations: "",
    position: 2,
    product_type: 0,
    exclude_products: 6,
    product: "7541718548694,7541707735254",
    variant: "",
    collection: "",
    collection_image: "",
    inventory: 0,
    tags: "",
    excludeTags: "",
    enable_visibility_date: false,
    from_date: null,
    to_date: null,
    enable_discount_range: false,
    discount_type: 1,
    discount_from: null,
    discount_to: null,
    public_img_url:
      "https://cdn.shopify.com/s/files/1/0609/6840/3158/t/35/assets/ec_2022_lg_png?v=1666788111",
    label_text: "Hello!",
    label_text_color: "#ffffff",
    label_text_font_size: 12,
    label_text_background_color: "#ff7f50",
    label_text_no_image: 1,
    label_text_in_stock: "In Stock",
    label_text_out_stock: "Sold out",
    label_shadow: 0,
    label_shape: null,
    label_opacity: 100,
    label_border_radius: 0,
    label_text_style: 0,
    label_shadow_color: "#808080",
    label_text_enable: 0,
    label_text_font_family: null,
    related_product_tag: null,
    customer_tags: null,
    exclude_customer_tags: null,
    customer_type: "allcustomers",
    exclude_customers: "all_customer_tags",
    collection_image_type: 0,
    label_on_image: "2",
    first_image_tags: null,
    label_type: 1,
    badge_type: 0,
    custom_selector: null,
    margin_top: 0,
    margin_bottom: 0,
    mobile_font_size_label: 12,
    label_text_id: 59000,
    emoji: null,
    emoji_position: null,
    transparent_background: null,
    custom_page: null,
    check_custom_page: "0",
    margin_left: 0,
    instock: null,
    enable_price_range: 0,
    price_range_from: null,
    price_range_to: null,
    enable_product_publish: 0,
    product_publish_from: null,
    product_publish_to: null,
    enable_countdown_timer: 0,
    option_format_countdown: 0,
    countdown_time: null,
    option_end_countdown: null,
    start_day_countdown: null,
    public_url_s3:
      "https://shopify-production-product-labels.s3.us-east-2.amazonaws.com/public/static/base/images/customer/28098/ec_2022_lg.png",
    enable_visibility_period: 0,
    visibility_period: 1,
    createdAt: "2022-10-26T12:41:52.000Z",
    customer_ids: null,
    exclude_customer_ids: null,
    exclude_product_ids: null,
    angle: 0,
    toolTipText: "",
    mobile_width_label: 35,
    mobile_height_label: 33,
    mobile_fixed_percent_label: 1,
    desktop_width_label: 35,
    desktop_height_label: 33,
    desktop_fixed_percent_label: 1,
    mobile_position: 2,
    desktop_label_unlimited_top: 33,
    desktop_label_unlimited_left: 33,
    desktop_label_unlimited_width: 30,
    desktop_label_unlimited_height: 30,
    mobile_label_unlimited_top: 33,
    mobile_label_unlimited_left: 33,
    mobile_label_unlimited_width: 30,
    mobile_label_unlimited_height: 30,
    mobile_margin_top: 0,
    mobile_margin_left: 0,
    mobile_margin_bottom: 0,
    enable_fixed_time: 0,
    fixed_time: null,
    statusLabelHoverText: 0,
    labelHoverTextLink: "",
    statusLabelAltText: 0,
    labelAltText: "",
    enable_multi_badge: null,
  },
];
